import { render, staticRenderFns } from "./GamepadMidiController.vue?vue&type=template&id=42372dba&scoped=true&"
import script from "./GamepadMidiController.vue?vue&type=script&lang=js&"
export * from "./GamepadMidiController.vue?vue&type=script&lang=js&"
import style0 from "./GamepadMidiController.vue?vue&type=style&index=0&id=42372dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42372dba",
  null
  
)

export default component.exports